(async () => {
  
  const { Fancybox } = await import("@fancyapps/ui");
  
  if (!customElements.get('size-guide')) {
    
    class SizeGuide extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector("[data-size-guide-content]");
        this.trigger = this.querySelector("[data-size-guide-trigger]");
        this.url = this.trigger?.dataset.url;
        this.trigger?.addEventListener('click', () => this.handleTrigger());
      }

      /**
       * handleTrigger
       */
      async handleTrigger() {

        // Disable the trigger
        this.trigger.setAttribute('disabled', true);

        // Fetch data
        const pageContent = await fetch(this.url)
          .then(response => {
            return response.text();
          });

        // Parse string to DOM Document
        const html = new DOMParser().parseFromString(pageContent, 'text/html').querySelector('.container-content').innerHTML;
        
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }

        // Fill hidden holder with fetched html
        this.content.innerHTML = html;
        
        // Trigger fancybox
        Fancybox.show(
          [
            { 
              src: html, 
              type: "html"
            }
          ], 
          {
            mainClass: "size-guide-fancybox"
          }
        );
      
        // Unlock the button again
        this.trigger.removeAttribute('disabled');

      }

    }

    window.SizeGuide = SizeGuide;

    customElements.define('size-guide', SizeGuide);

  }

})();